import type { Product, ProductAttributeGroupOfValue, ProductForCustomer } from "../Product.js";

interface Combination<TProduct extends Product | ProductForCustomer> {
	variant: TProduct["variants"][number];
	attributes: ProductAttributeGroupOfValue[];
}

export function getProductVariantAttributeCombinations<TProduct extends Product | ProductForCustomer>(
	product: Pick<TProduct, "variants" | "attributeGroups">,
): Combination<TProduct>[] {
	const combinations: Combination<TProduct>[] = [];
	for (const variant of product.variants) {
		if (product.attributeGroups.length === 0) {
			combinations.push({ variant, attributes: [] });
			continue;
		}

		let attributeCombinations: ProductAttributeGroupOfValue[][] = [[]];

		for (const group of product.attributeGroups) {
			const nextCombinations: ProductAttributeGroupOfValue[][] = [];

			for (const combination of attributeCombinations) {
				for (const value of group.values) {
					nextCombinations.push([
						...combination,
						{
							...group,
							value,
						},
					]);
				}
			}

			attributeCombinations = nextCombinations;
		}

		for (const attributes of attributeCombinations) {
			combinations.push({
				variant,
				attributes,
			});
		}
	}
	return combinations;
}
